import React from 'react'
import { Consumer } from './StoreContext'

export default function withStore(Component) {
  return function StoreComponent(props) {
    return (
      <Consumer>{store => <Component {...props} store={store} />}</Consumer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/lib/withStore.js